<template>
  <layout 
    :showuserinfo="false" 
    title="Cukai Tanah:: Penguatkuasaan" 
    :crumbs="crumbs"
  >

    <div class="table-hardcode">
        
        <!-- -->
        <z-page
          title="Carian Penguatkuasaan : Notis Pentadbiran"
          icon="fal fa-search"
          class="mt3"
        >
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                     <div class="xs4 mr3">
                        <z-input 
                          label="No. Hak Milik" 
                          v-model="search.name" 
                          placeholder="Sila Masukkan No. Hak Milik"
                          name=""
                        />
                    </div>
                    <div class="xs4 mr3">
                      <z-input 
                          label="No. Akaun" 
                          v-model="search.amaun" 
                          placeholder="Sila Masukkan No. Akaun"
                          name="" />
                    </div>
                    <div class="xs4">
                      <z-input 
                          label="Syarat Tanah" 
                          v-model="search.mukim" 
                          placeholder="Sila Masukkan Syarat Tanah"
                          name=""  
                      />
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs4 mr3">
                      <z-input 
                          label="Julat Amaun Tunggakan" 
                          v-model="search.jenishm" 
                          placeholder="Sila Masukkan Julat Amaun Tunggakan"
                          name=""  
                      />
                    </div>
                    <div class="xs4 mr3">
                      <z-input 
                          label="Usia Tunggakan" 
                          v-model="search.amaun" 
                          placeholder="Sila Masukkan Usia Tunggakan"
                          name="" 
                      />
                    </div>
                    <div class="xs4">
                      <z-input 
                          label="Mukim dibawah Daerah Pengguna" 
                          v-model="search.mukim" 
                          placeholder="Sila Masukkan Mukim dibawah Daerah Pengguna"
                          name=""  
                      />
                    </div>
                </w-flex>
                <w-flex class="mt3" wrap align-center justify-end>
                    <div class="spacer" />
                    <w-button
                      class="my1 mr2">
                      <i class="fal fa-redo mr2" style="font-size: 11px;"></i> Isi Semula
                    </w-button>

                    <w-button
                      class="my1 mr2">
                      <i class="fal fa-search mr2" style="font-size: 11px;"></i>Cari
                    </w-button>
                  </w-flex>
            </w-form>
        </z-page>

        <div class="w-card__content content-hardcode mt3">
          <table class="table-dashboard" width="100%" >
            <thead>
              <tr>
                 <td>Bil.</td>
                 <td>Nama Pemilik</td>
                 <td>ID Pemilik</td>
                 <td>No. Hak Milik</td>
                 <td>No. Akaun</td>
                 <td>Kategori Hak Milik</td>
                 <td>Jenis Hak Milik</td>
                 <td>Daerah</td>
                 <td>Mukim / Bandar / Pekan</td>
                 <td>Amaun Tunggakan (RM)</td>
                 <td>Usia Tunggakan</td>
                 <td><w-checkbox></w-checkbox></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                 <td>1.</td>
                 <td>New Khoi Sio</td>
                 <td>920805523768</td>
                 <td>771728GM00000129</td>
                 <td>686218456696982</td>
                 <td>&nbsp;</td>
                 <td>&nbsp;</td>
                 <td>&nbsp;</td>
                 <td>&nbsp;</td>
                 <td>40.00</td>
                 <td>&nbsp;</td>
                 <td><w-checkbox></w-checkbox></td>
              </tr>
              <tr>
                 <td>2.</td>
                 <td>New Khoi Sio</td>
                 <td>920805523768</td>
                 <td>771728GM00000129</td>
                 <td>686218456696982</td>
                 <td>&nbsp;</td>
                 <td>&nbsp;</td>
                 <td>&nbsp;</td>
                 <td>&nbsp;</td>
                 <td>40.00</td>
                 <td>&nbsp;</td>
                 <td><w-checkbox></w-checkbox></td>
              </tr>
           </tbody>
            </table>
        </div>

        <w-flex class="mt3" wrap align-center justify-end>
          <div class="spacer" />
          <w-button
            class="my1 mr2">
            Jana Notis Pentadbiran
          </w-button>
        </w-flex>
        <!-- -->
    </div>

  </layout>
</template>

<script>
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: 'cukai-tanah',
        reload: true,
        crumbs: [
          { label: this.$page.props.app_name, route: '/' },
          { label: 'Cukai Tanah', route: '/cukai-tanah/dashboard' },
          { label: 'Senarai', route: '/cukai-tanah/senarai' },
        ],
        form: {
        },
        search: {
          name: '',
          mukim: '',
          amaun: 0,
          jenishm: ''
        },
      }
  },
  methods: {
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>